class OptionsBase {
  constructor(params) {
    this.layoutParams = params.layoutParams;
    this.cards = params.cards;
    this.validateCard = params.validateCard;
    this.isPreviewMode = params.isPreviewMode;

    this.init();
  }

  init = () => {
    this.bindEvents();
  }

  handleEvents = optionInputs => {
    optionInputs.forEach((optionInput) => {
      // Add click event listener to inputs
      optionInput.addEventListener('click', (e) => {
        const parent = e.currentTarget.parentNode;
        if (e.currentTarget.getAttribute('type') === 'radio') {
          // Clear Radio field
          parent.closest('.jfQuestion-fields').querySelectorAll('.jfRadio').forEach(radio => radio.setAttribute('aria-checked', 'false'));
          // Clear YesNo field
          parent.closest('.jfQuestion-fields').querySelectorAll('.jfYesno').forEach(radio => radio.setAttribute('aria-checked', 'false'));
          parent.setAttribute('aria-checked', 'true');
        } else if (e.currentTarget.getAttribute('type') === 'checkbox') {
          parent.setAttribute('aria-checked', parent.getAttribute('aria-checked') === 'false');
        }
      });

      // Option label: Navigating tab focuses to labels,
      // so we need to add keyboard events to labels
      optionInput.parentNode.addEventListener('keydown', (e) => {
        // 13: ENTER, 32: SPACE
        if (e.keyCode === 13 || e.keyCode === 32) {
          if (e.target.type !== 'text') { // if user is typing to other option don't interrupt
            e.currentTarget.click();
          }
        }
      });
    });
  }

  bindEvents = () => {
    this.handleEvents(this.yesNos);
  }

  get radios() {
    return document.querySelectorAll('input.jfRadio-input');
  }

  get checkboxes() {
    return document.querySelectorAll('input.jfCheckbox-input');
  }

  get yesNos() {
    return document.querySelectorAll('input.jfYesno-input');
  }

}

export default OptionsBase;
